<small class="debug"> {{ me }} </small>
<div [@loginState]="loginState" class="login-page" id="appLogin">
    <!--  [ngClass.xs]="'xs-login-page'" -->
    @if (showSweepLine) {
        <div class="top-gradient-line"></div>
    }
    @if (!m_mode) {
        <div class="langTheme site-mode">
            <app-local-diag [setLargeMode]="true"></app-local-diag>
            <app-theme-selector></app-theme-selector>
        </div>
    }
    <br/>
    <form autocomplete="off" class="form-signin" role="form">
        @switch (m_currentViewMode) {
            @case (m_viewMod.INIT) {
                <div>
                    <mat-icon>refresh</mat-icon>
                    init mode
                </div>
            }
            @case (m_viewMod.LOGIN_IN_PROGRESS) {
                <div>
                    <app-loading [@fadeIn] [type]="'ai'" [size]="'80px'" [style]="{'margin-top': '150px'}"></app-loading>
                    <div class="text-center" style="margin-top: 20px;">
                        <span flashlightText style="font-size: 1.1em; font-weight: bold">Loading studio...</span>
                    </div>
                </div>
            }
            @case (m_viewMod.LOGIN) {
                <div>
                    <h2 class="form-signin-heading"></h2>
                    <div class="homeLink">
                        @if (m_mode !== 'CHECKOUT') {
                            <app-logo [overrideDefaultClass]="stylesObj"></app-logo>
                        }
                        <br/>
                        @if (!isWhiteLabeled) {
                            <mat-label class="textColorFive" style="font-size: 10px">{{ 'account.freeSignage' | transloco }}</mat-label>
                        }
                        @switch (m_mode) {
                            @case ('CREATE_ACCOUNT') {
                                <div>
                                    <mat-label class="textColorFive" style="font-size: 14px">
                                        [ {{ 'general.createAccount2' | transloco }} ]
                                    </mat-label>
                                </div>
                            }
                            @case ('CHECKOUT') {
                                <div>
                                    <mat-label class="textColorFive" style="font-size: 14px">
                                        [ {{ 'general.readyForCheckout' | transloco }} ]
                                    </mat-label>
                                </div>
                            }
                            @default {
                                <div>
                                    @if (!isWhiteLabeled) {
                                        <mat-label class="textColorFive" style="font-size: 14px">
                                            [ {{ 'general.amazed' | transloco }} ]
                                        </mat-label>
                                    }
                                </div>
                            }
                        }
                    </div>
                    <br/>
                    <br/>
                    <div>
                        <small class="debug"> {{ me }} </small>
                        <!--                    <div style="overflow: hidden">-->
                        <!--                        <iframe [src]="'https://www.cnn.com' | safeHTML" align="middle" style="border:none;overflow: hidden"></iframe>-->
                        <!--                    </div>-->
                        <mat-form-field [ngClass]="{disabledInput: disabledLoginInputs}">
                            <mat-label>{{ (m_mode === 'CREATE_ACCOUNT' ? 'account.email' : 'account.userEmail') | transloco }}</mat-label>
                            <input #userLogin inputrestriction="login" (invalidCharacter)="messageInvalidCharChosen($event)" (blur)="checkUsername()" [disabled]="disabledLoginInputs"
                                   autocomplete="off" matInput (keyup.enter)="passFocus($event)" #userName spellcheck="false" type="text"
                                   name="m_user" [(ngModel)]="m_user" placeholder="" required>
                        </mat-form-field>

                        <!-- main password -->
                        <mat-form-field [ngClass]="{disabledInput: disabledLoginInputs}">
                            <mat-label>{{ 'account.password' | transloco }}</mat-label>
                            <input [opts]="'password'" inputrestriction="password" (invalidCharacter)="messageInvalidCharChosen($event)" [disabled]="disabledLoginInputs" autocomplete="off" matInput
                                   (keyup.enter)="m_mode === 'CREATE_ACCOUNT' ? passFocusSecondPass() : signInWithEmail()"
                                   #userPass type="password" [(ngModel)]="m_pass" name="m_pass"
                                   placeholder="" required>
                        </mat-form-field>

                        <!-- repeat password -->
                        @if (m_mode === 'CREATE_ACCOUNT') {
                            <mat-form-field [ngClass]="{disabledInput: disabledLoginInputs}">
                                <mat-label>{{ 'account.repeatPass' | transloco }}</mat-label>
                                <input inputrestriction="password" [opts]="'password'" (invalidCharacter)="messageInvalidCharChosen($event)" [disabled]="disabledLoginInputs" autocomplete="off" matInput (keyup.enter)="createAccount($event)"
                                       #userPass2 type="password" [(ngModel)]="m_passRepeat" name="m_passRepeat"
                                       placeholder="" required>
                            </mat-form-field>
                        }
                    </div>
                    <br/>
                    <br/>

                    @if ((privateServer?.length > 10  || ldapServer?.length > 10) === false) {
                        <div>
                            @if (!isWhiteLabeled) {
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithEmail'}" class="loginCreateAccountText"
                                       matTooltipPosition="above" matTooltip="{{'account.loginNow' | transloco}}"
                                       (click)="onLoginWith('loginWithEmail',$event)" href="#">
                                        <fa-icon size="1x" [icon]="faEnvelope"></fa-icon>
                                    </a>
                                    <!-- future support for Guest login... maybe -->
                                    <!--  <a [ngClass]="{'selectedNav':selectedLoginMode === 'continueAsGuest'}" class="loginCreateAccountText" matTooltipPosition="above" matTooltip="{{'account.continueAsGuest' | transloco}}" (click)="onLoginWith('continueAsGuest',$event)" href="#">-->
                                    <!--       <fa-icon [icon]="faUser"></fa-icon>-->
                                    <!--  </a>-->
                                    <!--                    <asl-google-signin-button type='icon' size='medium'></asl-google-signin-button>-->
                                    <!--                    <asl-google-signin-button></asl-google-signin-button>-->
                                    <!--                    <google-signin-butt></google-signin-butt>-->
                                    <div [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithGL'}" class="loginCreateAccountText" matTooltipPosition="above" (click)="onLoginWith('loginWithGL',$event)" href="#">
                                        <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                                        <fa-icon size="1x" [icon]="faGoogle"></fa-icon>
                                    </div>
                                    <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithAmazon'}" class="loginCreateAccountText faAmazon"
                                       matTooltipPosition="above" matTooltip="{{'account.loginWithAmazon' | transloco}}"
                                       (click)="onLoginWith('loginWithAmazon',$event)" href="#">
                                        <fa-icon class="fixAmazon" size="1x" [icon]="faAmazon"></fa-icon>
                                    </a>
                                    <!-- disabled for facebook now -->
                                    <!--             <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithFB'}" class="loginCreateAccountText"-->
                                    <!--                       matTooltipPosition="above" matTooltip="{{'account.loginWithFB' | transloco}}"-->
                                    <!--                       (click)="onLoginWith('loginWithFB',$event)" href="#">-->
                                    <!--                        <fa-icon [icon]="faFacebook"></fa-icon>-->
                                    <!--                    </a>-->
                                    <!--                    <a [ngClass]="{'selectedNav':selectedLoginMode === 'loginWithPrivates'}" class="loginCreateAccountText" matTooltipPosition="above" matTooltip="{{'account.loginWithLdapPrivates' | transloco}}" (click)="onLoginWith('loginWithPrivates',$event)" href="#">-->
                                    <!--                        <fa-icon [icon]="faServer"></fa-icon>-->
                                    <!--             </a>-->
                                </div>
                            }
                        </div>
                    }
                    <br/>
                    <ul class="loginButtons">
                        @switch (selectedLoginMode) {
                            @case ('loginWithEmail') {
                                <div>
                                    @if (m_mode === 'CREATE_ACCOUNT') {
                                        <!-- mismatch uses the SAME raw comparison createAccount() enforces, so the
                                             button state and the submit check can never disagree -->
                                        <button type="button" (click)="createAccount($event)"
                                                [disabled]="(m_user?.trim()?.length || 0) < 3 || (m_pass?.trim()?.length || 0) < 3 || (m_passRepeat?.trim()?.length || 0) < 3 || m_pass !== m_passRepeat"
                                                class="full-button" mat-stroked-button>
                                            {{ 'account.continue' | transloco }}
                                            <fa-icon [icon]="faSignInAlt"></fa-icon>
                                        </button>
                                    }
                                    @if (m_mode !== 'CREATE_ACCOUNT') {
                                        <!-- manual email login only - social logins (google/amazon) have their own flows and are NOT gated -->
                                        <button type="button" (click)="signInWithEmail()"
                                                [disabled]="!autofillDetected && ((m_user?.trim()?.length || 0) < 3 || (m_pass?.trim()?.length || 0) < 3)"
                                                class="full-button" mat-stroked-button>
                                            <ng-container>
                                                {{ 'account.loginNow' | transloco }}
                                                <fa-icon [icon]="faSignInAlt"></fa-icon>
                                            </ng-container>
                                        </button>
                                    }
                                </div>
                            }
                            @case ('continueAsGuest') {
                                <div>
                                    <button class="guestButton" type="button" (click)="signInGuest($event)" class="full-button" mat-stroked-button>
                                        {{ 'account.continueAsGuest' | transloco }}
                                        <fa-icon [icon]="faUser"></fa-icon>
                                    </button>
                                </div>
                            }
                            @case ('loginWithAmazon') {
                                <div>
                                    @if (m_mode === 'CREATE_ACCOUNT') {
                                        <button class="amazonButton full-button" type="button" (click)="onLoginAmazonPopup($event)" mat-stroked-button>
                                            {{ 'account.createWithAmazon' | transloco }}
                                            <fa-icon [icon]="faAmazon"></fa-icon>
                                        </button>
                                    }
                                    <!--                        <a *ngIf="m_mode === 'CREATE_ACCOUNT'" (click)="backToLogin()" mat-button class="backToMain">-->
                                    <!--                            <mat-icon>keyboard_arrow_left</mat-icon>-->
                                    <!--                            {{'account.back' | transloco}}-->
                                    <!--                        </a>-->
                                    @if (m_mode !== 'CREATE_ACCOUNT') {
                                        <button class="amazonButton full-button" type="button"
                                                (click)="onLoginAmazonPopup($event)" mat-stroked-button>{{ 'account.loginWithAmazon' | transloco }}
                                            <fa-icon [icon]="faAmazon"></fa-icon>
                                        </button>
                                    }
                                </div>
                            }
                            @case ('loginWithGL') {
                                <div>
                                    <!--                        <asl-google-signin-button type='icon' size='medium'></asl-google-signin-button>-->
                                    <!--                        <asl-google-signin-button></asl-google-signin-button>-->
                                    <!--                        <google-signin-butt></google-signin-butt>-->
                                    @if (m_mode === 'CREATE_ACCOUNT') {
                                        <div class="googleButton full-button" type="button" (click)="signInWithGoogle()">
                                            <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                                            <!--                            <fa-icon [icon]="faGoogle"></fa-icon>-->
                                        </div>
                                    }
                                    @if (m_mode !== 'CREATE_ACCOUNT') {
                                        <div class="googleButton full-button" type="button" (click)="signInWithGoogle()">
                                            <google-signin-butt [selectable]="showGoogleLogin"></google-signin-butt>
                                            <!--                            <fa-icon [icon]="faGoogle"></fa-icon>-->
                                        </div>
                                    }
                                </div>
                            }
                            @case ('loginWithFB') {
                                <div>
                                    @if (m_mode === 'CREATE_ACCOUNT') {
                                        <button class="facebookButton full-button" type="button" (click)="signInWithFB()"
                                                mat-stroked-button>{{ 'account.createWithFB' | transloco }}
                                            <fa-icon [icon]="faFacebook"></fa-icon>
                                        </button>
                                    }
                                    @if (m_mode !== 'CREATE_ACCOUNT') {
                                        <button class="facebookButton full-button" type="button" (click)="signInWithFB()"
                                                mat-stroked-button>{{ 'account.loginWithFB' | transloco }}
                                            <fa-icon [icon]="faFacebook"></fa-icon>
                                        </button>
                                    }
                                </div>
                            }
                        }

                        <!--                    <div *ngSwitchCase="'loginWithPrivates'" fxLayout="row">-->
                        <!--                        <button fxLayout *ngIf="m_mode === 'CREATE_ACCOUNT'" class="privatesButton privatesButtonMove" type="button" (click)="createWithPrivates()" mat-stroked-button>{{'account.createWithPrivates2' | transloco}}</button>-->
                        <!--                        <button fxLayout *ngIf="m_mode !== 'CREATE_ACCOUNT'" class="privatesButton privatesButtonMove" type="button" (click)="signInWithPrivates()" mat-stroked-button>{{'account.loginWithPrivates3' | transloco}}</button>-->
                        <!--                        <button fxLayout mat-flat-button class="privatesButtonSettings privatesButtonMove" (click)="setupWithPrivates()" matTooltip="{{'general.settings' | transloco}}">-->
                        <!--                            <mat-icon style="font-size: 1.4em; position: relative; left: -11px; top: 2px">build</mat-icon>-->
                        <!--                        </button>-->
                        <!--                    </div>-->

                        @if (showCreateAccount) {
                            <div>
                                @if (m_mode !== 'CREATE_ACCOUNT') {
                                    <div style="padding-top: 12px">
                                        {{ 'account.or' | transloco }}
                                    </div>
                                }
                                <br/>
                                @if (m_mode !== 'CREATE_ACCOUNT') {
                                    <button type="button" (click)="createNewAccount($event)" class="full-button" mat-stroked-button>
                                        {{ 'account.createNewAccount2' | transloco }}
                                        <fa-icon [icon]="faKey"></fa-icon>
                                    </button>
                                }
                            </div>
                        }
                    </ul>
                    <br/>
                    @if (!isWhiteLabeled) {
                        <div class="link-options-modern">
                            @if (m_mode !== 'CREATE_ACCOUNT') {
                                <button type="button" mat-icon-button class="link-option-btn"
                                        matTooltip="{{'account.options' | transloco}}"
                                        (click)="onShowOptions('settings',$event)"
                                        [class.active]="selectedOptions === 'settings'">
                                    <mat-icon>settings</mat-icon>
                                </button>
                            }
                            <button type="button" mat-icon-button class="link-option-btn"
                                    matTooltip="{{'account.downloads' | transloco}}"
                                    routerLink="/getstarted/downloads">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                            <button type="button" mat-icon-button class="link-option-btn"
                                    matTooltip="{{'account.cart' | transloco}}"
                                    routerLink="/shopping-cart/list">
                                <mat-icon>shopping_cart</mat-icon>
                            </button>
                            <button type="button" mat-icon-button class="link-option-btn"
                                    matTooltip="{{'account.products' | transloco}}"
                                    routerLink="/shopping-cart/products">
                                <mat-icon>local_offer</mat-icon>
                            </button>
                            <button type="button" mat-icon-button class="link-option-btn"
                                    matTooltip="{{'account.homePage' | transloco}}"
                                    (click)="onShowOptions('home',$event)">
                                <mat-icon>home</mat-icon>
                            </button>
                            <button type="button" mat-icon-button class="link-option-btn"
                                    matTooltip="{{'account.help' | transloco}}"
                                    (click)="navigateToParam($event, '/shopping-cart/helpdesk?back=true')">
                                <mat-icon>help_outline</mat-icon>
                            </button>
                        </div>
                    } @else {
                        <a (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                            {{ 'account.forgotPassword' | transloco }}
                        </a>
                    }
                    <br/>
                    @if (isWhiteLabeled && !showCreateAccount) {
                        <div>
                            <a id="forgotPassword" fxFlex fxLayoutAlign="center center" (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                                <mat-icon>report</mat-icon>
                                <span style="margin-left: 5px;">{{ 'account.forgotPassword' | transloco }}</span>
                            </a>
                        </div>
                    }
                    @if (privateServer && privateServer.length > 10) {
                        <span class="privEnabled">
                            <mat-icon>verified_user</mat-icon>
                            {{ 'account.privateEnabled' | transloco }}
                        </span>
                    }
                    <br/>
                    <br/>
                    @if (ldapServer && ldapServer.length > 10) {
                        <span class="privEnabled" style="position: relative; top: -10px; left: -3px">
                            <mat-icon>verified_user</mat-icon>
                            {{ 'account.ldapEnabled' | transloco }}
                        </span>
                    }
                    <br/>
                    @if (selectedOptions === 'settings') {
                        <div class="settings-panel-modern">
                            <mat-checkbox [checked]="m_rememberMe" (change)="m_rememberMe = $event.checked" class="settings-checkbox">
                                {{ 'account.rememberMe' | transloco }}
                            </mat-checkbox>
                            <div class="settings-links">
                                <a class="settings-link" (click)="$event.preventDefault(); setViewMode(m_viewMod.FORGOT_PASSWORD)" href="#">
                                    <mat-icon>lock_reset</mat-icon>
                                    <span>{{ 'account.forgotPassword' | transloco }}</span>
                                </a>
                                <a class="settings-link" (click)="$event.preventDefault(); setViewMode(m_viewMod.CHANGE_PASSWORD)" href="#">
                                    <mat-icon>vpn_key</mat-icon>
                                    <span>{{ 'account.changePassword' | transloco }}</span>
                                </a>
                                <a class="settings-link" (click)="$event.preventDefault(); setupWithPrivates()" href="#">
                                    <mat-icon>dns</mat-icon>
                                    <span>{{ 'account.advancedLogin' | transloco }}</span>
                                </a>
                            </div>
                            <div class="settings-version">
                                {{ 'account.version' | transloco }}: {{ appVersion }}
                            </div>
                        </div>
                    }
                    <br/>
                    <br/>
                    <br/>
                </div>
            }
            @case (m_viewMod.CHANGE_PASSWORD) {
                <div>
                    <app-change-password></app-change-password>
                </div>
            }
            @case (m_viewMod.FORGOT_PASSWORD) {
                <div>
                    <app-forgot-password></app-forgot-password>
                </div>
            }
            @case (m_viewMod.CHANGE_BUSINESS_NAME) {
                <div>
                    <app-business-rename></app-business-rename>
                </div>
            }
            @default {
                <div>
                    <h1>something went wrong</h1>
                    mode: {{ m_currentViewMode }}
                </div>
            }
        }
    </form>
</div>


<ng-template let-modal #privatesModal>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-icon style="position: relative; left: -4px; top: 6px">build</mat-icon>
        {{ 'placeholder.serverConnection' | transloco }}
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
        <br/>
        <br/>
        <div fxLayout="column" fxLayoutAlign="center center" class="privatesModalWrap">
            <div fxFlex>
                <mat-checkbox [checked]="privateServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('privateServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <mat-label>{{ 'account.privateSignage2' | transloco }}</mat-label>
                </mat-checkbox>
            </div>
            <div fxFlex>
                <mat-checkbox [checked]="ldapServer.length > 0"
                              (change)="onPrivatesCheckboxChanged('ldapServer', $event.checked)">
                    <mat-icon>storage</mat-icon>
                    <mat-label>LDAP {{ 'account.server' | transloco }}</mat-label>
                </mat-checkbox>
            </div>
            @if (isDev) {
                <div fxFlex>
                    <mat-checkbox [checked]="useDevServerPort"
                                  (change)="onToggleDevServerPort($event.checked)">
                        <mat-icon>developer_mode</mat-icon>
                        <mat-label>dev mode 9443</mat-label>
                    </mat-checkbox>
                </div>
            }
        </div>
        <br/>
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field [ngClass]="{disabledInput: privateServer.length === 0}" style="width: 80%" fxFlex>
                <input matInput
                       placeholder="{{'placeholder.privateServerDomain' | transloco}} (i.e.: https://master.example.com)"
                       (change)="onUpdatePrivatesStore('privateServer', $event.target['value'])"
                       [value]="privateServer" type="text" autocomplete="off"
                       [disabled]="privateServer.length === 0">
            </mat-form-field>
            <mat-form-field [ngClass]="{disabledInput: ldapServer.length === 0}" style="width: 80%" fxFlex>
                <input matInput
                       placeholder="{{'placeholder.privateLdapDomain' | transloco}} (i.e. server-address : domain-controller"
                       (change)="onUpdatePrivatesStore('ldapServer', $event.target['value'])"
                       [value]="ldapServer" type="text" autocomplete="off"
                       [disabled]="ldapServer.length === 0">
            </mat-form-field>
        </div>
    </h1>
    <br/>
    <br/>
</ng-template>
